// USER
export interface User {
  _objectType: string;
  Email: string;
  FirstName: string;
  LastName: string;
  MailingAddress: unknown;
  PasswordLastUpdated: string;
  PasswordMustChange: boolean;
  PhoneMobile: string;
  PhoneWork: string;
  ProfileImageS3Url: string;
  Title: unknown;
  Timezone: string;
  Language: string;
  IPAddress: string;
  Referer: string;
  UserAgent: string;
  LastLoginDateTime: string;
  OAuthGoogleProfileId: unknown;
  PersonAccount: unknown;
  DealPeople: unknown;
  LeadFormSubmissions: unknown;
  EmailListPerson: unknown;
  Account: Account;
  AccountUids: unknown;
  FullName: string;
  HasLoggedIn: boolean;
  OAuthIntegrationStatus: number;
  UserAgentPlatformBrowser: string;
  HasUnsubscribed: boolean;
  DiscordUser: unknown;
  IsConnectedToDiscord: boolean;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
  ExperimentTest?: boolean;
}

export interface Account {
  _objectType: string;
  Name: string;
  ClientIdentifier: unknown;
  InvoiceNotes: string;
  IsDemo: boolean;
  BillingAddress: unknown;
  MailingAddress: unknown;
  AccountStage: number;
  PaymentInformation: unknown;
  PersonAccount: unknown;
  Subscriptions: unknown;
  Deals: unknown;
  LastLoginDateTime: string;
  AccountSpecificPageUrl1: unknown;
  AccountSpecificPageUrl2: unknown;
  AccountSpecificPageUrl3: unknown;
  AccountSpecificPageUrl4: unknown;
  AccountSpecificPageUrl5: unknown;
  AccountSpecificPageUrl6: unknown;
  AccountSpecificPageUrl7: unknown;
  AccountSpecificPageUrl8: unknown;
  AccountSpecificPageUrl9: unknown;
  AccountSpecificPageUrl10: unknown;
  RewardFulReferralId: unknown;
  TaxIds: unknown;
  TaxStatus: string;
  AccountStageLabel: string;
  CurrentSubscription: CurrentSubscription;
  DomainName: unknown;
  HasLoggedIn: boolean;
  LatestSubscription: unknown;
  LifetimeRevenue: number;
  PrimaryContact: PrimaryContact;
  PrimarySubscription: unknown;
  RecaptchaToken: unknown;
  TaxId: unknown;
  TaxIdIsInvalid: boolean;
  TaxIdType: unknown;
  WebflowSlug: unknown;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
  main_goal?: string; // Main goal selected during onboarding
  JooiceVersion?: string;
  JooiceFlow?: string;
}

export interface CurrentSubscription {
  _objectType: string;
  BillingRenewalTerm: number;
  Account: unknown;
  Plan: Plan;
  Quantity: number;
  StartDate: string;
  EndDate: unknown;
  ExpirationDate: unknown;
  RenewalDate: string;
  NewRequiredQuantity: unknown;
  IsPlanUpgradeRequired: boolean;
  PlanUpgradeRequiredMessage: unknown;
  SubscriptionAddOns: unknown[];
  DiscountCouponSubscriptions: unknown[];
  DiscountCode: unknown;
  LatestInvoice: unknown;
  Rate: number;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}

export interface Plan {
  Name: string;
  Uid: string;
}

export interface PrimaryContact {
  _objectType: string;
  Email: string;
  FirstName: string;
  LastName: string;
  MailingAddress: unknown;
  PasswordLastUpdated: unknown;
  PasswordMustChange: boolean;
  PhoneMobile: string;
  PhoneWork: string;
  ProfileImageS3Url: unknown;
  Title: unknown;
  Timezone: unknown;
  Language: unknown;
  IPAddress: unknown;
  Referer: unknown;
  UserAgent: unknown;
  LastLoginDateTime: unknown;
  OAuthGoogleProfileId: unknown;
  PersonAccount: unknown;
  DealPeople: unknown;
  LeadFormSubmissions: unknown;
  EmailListPerson: unknown;
  Account: unknown;
  AccountUids: unknown;
  FullName: string;
  HasLoggedIn: boolean;
  OAuthIntegrationStatus: number;
  UserAgentPlatformBrowser: string;
  HasUnsubscribed: boolean;
  DiscordUser: unknown;
  IsConnectedToDiscord: boolean;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}

// TOKEN
export interface IOutsetaToken {
  nbf: number;
  exp: number;
  iss: string;
  client_id: string;
  scope: string[];
  sub: string;
  auth_time: number;
  idp: string;
  email: string;
  email_verified: boolean;
  family_name: string;
  given_name: string;
  name: string;
  nameid: string;
  'outseta:accountUid': string;
  'outseta:isPrimary': string;
  'outseta:subscriptionUid': string;
  'outseta:planUid': string;
  'outseta:addOnUids': string[];
  amr: string[];
  aud: string;
  iat: number;
}

export enum EAccountStageLabel {
  TRIAL = 'Trialing',
  UNSUBSCRIBED = 'Cancelling',
  SUBSCRIBED = 'Subscribing',
}
